export default __webpack_public_path__ + "static/media/aws_certified_cloud_practitioner.e6fb8daf.png";